function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(90 -1891)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21,
  height: 21,
  transform: "translate(-90 1891)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M10.875,3H17a1.75,1.75,0,0,1,1.75,1.75V17A1.75,1.75,0,0,1,17,18.75H10.875m0-15.75H4.75A1.75,1.75,0,0,0,3,4.75V17a1.75,1.75,0,0,0,1.75,1.75h6.125m0-15.75V18.75",
  transform: "translate(-89.938 1891.063)"
}));

var SvgColumns = function SvgColumns(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColumns, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/columns.f050f608.svg";
export { ForwardRef as ReactComponent };